module.exports = __webpack_public_path__ + "28bc5e5938ab5aacc9341c1943086c22.png";